import React from 'react'

export default ({ isOpen }) => {
	return (
		<div className={isOpen ? 'sidebar open' : 'sidebar'}>
			<h1>Sidebar</h1>
		</div>
	)
}
